import LanguageTypes from '../game/types/LanguageTypes';

const { EN, ES, JA } = LanguageTypes;

const REMOVE_SLASHES = /^\/{2,}/;

const fullLangPathMap = {
    [EN]: '',
    [ES]: '/es',
    [JA]: '/ja'
};

const baseLangPathMap = {
    [EN]: '',
    [ES]: '/es',
    [JA]: ''
};

const ROOT = '/';

export const getSanitizedRoot = (urlRoot = '') => {
    return urlRoot.replace(REMOVE_SLASHES, ROOT);
};

const getUrlRoot = (locale = EN, useFullLangMap = false) => {
    const langPathMap = useFullLangMap ? fullLangPathMap : baseLangPathMap;

    return langPathMap[locale] ?? langPathMap[EN];
};

export default getUrlRoot;
